import axios from "axios";

const BASE =
  process.env.REACT_APP_API_BASE || "https://workspace.alearninglab.com/api";

export const http = axios.create({
  baseURL: BASE.replace(/\/$/, ""),
  headers: { "Content-Type": "application/json" },
});

export const fetchPrograms = () =>
  http.get("/programs").then((r) => r.data.programs ?? []);

export const fetchLocations = () =>
  http.get("/locations").then((r) => r.data.locations ?? []);

export const fetchConsultationConfig = () =>
  http.get("/consultation/config").then((r) => r.data);

export const submitContact = (payload) => http.post("/contact", payload);

export const submitConsultation = (payload) => http.post("/consultation", payload);

export function formatInr(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return "";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(amount));
}
